import styled from '@emotion/styled';
import Wrapper from '@common/pages/Wrapper';
import {sizes} from 'patient-ping-remedy/packages/theme';

export const AnalyticsWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;

  & > h1 {
    padding-top: ${sizes.large};
  }

  & > h1,
  & > div {
    padding-left: ${sizes.large};
    padding-right: ${sizes.large};
  }
`;
